import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface ICreateDriveViewFolderParams {
  parentFolderId: string;
  name: string;
}

export interface ICreateDriveViewFolderResponse {
  folder: { id: string };
}

export async function createDriveViewFolder({
  parentFolderId,
  name,
}: ICreateDriveViewFolderParams): Promise<
  IApiResponse<ICreateDriveViewFolderResponse>
> {
  const response = await fetcher('drive-view/folder', {
    method: 'POST',
    body: { parentFolderId, name },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to create folder',
      statusCode: response.status,
      data: null,
    };
  }

  const body: ICreateDriveViewFolderResponse = await response.json();
  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: body,
  };
}
